module.exports = __webpack_public_path__ + "img/dsci0011.b6801364.jpg";